import type React from 'react'

type Props = {
  className?: string
  size?: number
  left?: number
}

const IconCheck: React.FC<Props> = ({ className, size = 20, left = 4 }) => {
  return (
    <svg
      style={{ left: `${left}px` }}
      width={size}
      height={size}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2734 2.80664C13.332 2.74805 13.3906 2.71875 13.5078 2.71875C13.5957 2.71875 13.6836 2.74805 13.7715 2.80664L14.5918 3.65625C14.6504 3.71484 14.709 3.80273 14.709 3.89062C14.709 4.00781 14.6504 4.0957 14.5918 4.1543L5.80273 12.9434C5.74414 13.002 5.65625 13.0312 5.56836 13.0312C5.45117 13.0312 5.36328 13.002 5.30469 12.9434L1.4082 9.01758C1.32031 8.95898 1.29102 8.90039 1.29102 8.7832C1.29102 8.69531 1.32031 8.60742 1.4082 8.51953L2.22852 7.69922C2.28711 7.64062 2.375 7.58203 2.49219 7.58203C2.58008 7.58203 2.66797 7.64062 2.72656 7.69922L5.56836 10.541L13.2734 2.80664Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default IconCheck
